import { PasscodeSuccessCheck } from '../../assets/icons/icons';
import './SuccessCheckBadge.css';

function SuccessCheckBadge({ className, icon: Icon = PasscodeSuccessCheck }) {
  return (
    <div
      className={['success-check-badge', className].filter(Boolean).join(' ')}
      aria-hidden="true"
    >
      <Icon className="success-check-badge__icon" />
    </div>
  );
}

export default SuccessCheckBadge;
